<template>
  <v-sheet class="fill-height d-flex pa-0 ma-0">
    <v-container class="content-container d-flex flex-column pa-0 ma-0">
      <v-row align="center" justify="center" align-content="center" no-gutters>
        <v-img
          :src="PlaylistArt"
          width="80px"
          max-width="80px"
          height="80px"
          max-height="80px"
        ></v-img>
      </v-row>
      <v-row
        class="content--chip my-2"
        align="center"
        justify="center"
        align-content="center"
        no-gutters
      >
        <base-chip size="small" density="compact">{{
          $t('message.playlists.upcoming')
        }}</base-chip>
      </v-row>
      <v-row align="center" justify="center" align-content="center" no-gutters>
        <span class="body-bold-xlarge neutral-20-dark--txt">{{
          $t('message.playlists.signUpToWaitlist.title')
        }}</span>
      </v-row>
      <v-row
        class="mt-6"
        align="center"
        justify="center"
        align-content="center"
        no-gutters
      >
        <span class="body-regular-large neutral-20-dark--txt">{{
          $t('message.playlists.signUpToWaitlist.subtitle')
        }}</span>
      </v-row>
      <v-row
        class="mb-6"
        align="center"
        justify="center"
        align-content="center"
        no-gutters
      >
        <span class="body-regular-base neutral-40-light--txt">{{
          $t('message.playlists.signUpToWaitlist.description')
        }}</span>
      </v-row>
      <v-row align="center" justify="center" align-content="center" no-gutters>
        <base-btn type="primary" @click="handleGoToWaitlistSubscribing">{{
          $t('message.playlists.signUpToWaitlist.action')
        }}</base-btn>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script>
import PlaylistArt from '@/assets/Playlists/UpcomingFeature/playlist.svg'
import BaseChip from '@/components/BaseComponents/BaseChip.vue'

export default {
  name: 'SignUpToWaitlist',
  components: { BaseChip },
  data() {
    return {
      PlaylistArt,
      waitlistSubscribingLink: 'https://forms.gle/yZpxrf9hBH8sHrM4A',
    }
  },
  methods: {
    handleGoToWaitlistSubscribing() {
      window.open(this.waitlistSubscribingLink, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.content-container {
  display: flex;
  justify-self: center;
  align-self: center;

  .neutral-40-light--txt {
    color: varFigma(neutral-40-light) !important;
  }
  .neutral-20-dark--txt {
    color: varFigma(neutral-20-dark) !important;
  }

  .content {
    &--chip::v-deep {
      .v-chip {
        border-radius: $spacing-05 !important;
        background: varFigma(brand-90) !important;
        border-color: varFigma(brand-90) !important;
        height: 20px !important;
        padding: 0px $spacing-03 !important;
        justify-content: center !important;
        align-items: center !important;

        pointer-events: none;

        .v-chip__content {
          color: varFigma(brand-20-darkest) !important;
          /* bold/smaller */
          font-family: Rubik !important;
          font-size: 12px !important;
          font-style: normal !important;
          font-weight: 500 !important;
          line-height: 150% !important; /* 18px */
          pointer-events: none;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>
